import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { BaseApiTemplateService } from "../../shared/base-api-template-service.model";
import { LabelContainerModel } from "../../../../../../models/aggregates/erp/label";
import { Core2Config } from "../../shared/core2Config";
import {
  ApiResponseModel,
  BasicApiResponseModel,
  PagingResponseModel,
} from "../../shared/api-response.model";
import { ApiVisa } from "../../shared/api-visa.model";
import {
  LabelCriteriaModelQuery,
  LabelQueryCriteriaClass,
} from "../../../criteria";
import { Observable } from "rxjs";
import { GenericDocContainerModel } from "../../../../../../models/aggregates/generic_doc";

@Injectable({
  providedIn: "root",
})

export class LazadaGetDocumentService extends BaseApiTemplateService<any> {
  readonly url =
    Core2Config.DOMAIN_URL +
    Core2Config.TENANT_DOMAIN_URL_PREFIX +
    Core2Config.ECOMSYNC_PREFIX +
    "lazada/getDocument";

  constructor(http: HttpClient) {
    super();
    this.apiUrl = this.url;
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ECOMSYNC_PREFIX +
      "lazada/getDocument";
    this.httpClient = http;
  }

  public printJasperPdf(
    branch_guid: string,
    doc_type: string,
    order_item_ids: string,
    visa: ApiVisa
  ): Observable<Blob> {
    let params;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = `${visa.api_domain_url}${this.endpoint_path}`;
    }

    params = new HttpParams()
      .set("branch_guid", branch_guid)
      .set("doc_type", doc_type)
      .set("order_item_ids", order_item_ids);

    return this.httpClient.get<Blob>(
      this.apiUrl,
      this.getHttpHeaderBlob(visa, params)
    );
  }

  public getDocument(branch_guid: string, doc_type: string, order_item_ids: string, visa: ApiVisa ) {
    let params;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = `${visa.api_domain_url}${this.endpoint_path}`;
    }

    params = new HttpParams()
      .set("branch_guid", branch_guid)
      .set("doc_type", doc_type)
      .set("order_item_ids", order_item_ids);

    const UrlByCriteria = this.apiUrl + '?branch_guid=' + branch_guid + '&doc_type=' + doc_type + '&order_item_ids=' + order_item_ids;
    return this.httpClient.get<PagingResponseModel<GenericDocContainerModel>>(UrlByCriteria, this.getHttpHeader(visa));
  }

  public getDocumentAll(branch_guid: string, doc_type: any, order_item_ids: string, visa: ApiVisa) {
    let params;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = `${visa.api_domain_url}${this.endpoint_path}/backoffice-ep/multi`;
    }

    const UrlByCriteria = this.apiUrl + '?branch_guid=' + branch_guid + '&doc_type_list=' + doc_type + '&order_item_ids=' + order_item_ids;
    return this.httpClient.get<Blob>(UrlByCriteria, this.getHttpHeaderBlob(visa));
  }
}
